<template>
    <div>
        <div class="site-header-slider">
            <el-carousel height="400px">
                <el-carousel-item v-if="item.display" v-for="(item, index) in bannerList" :key="index">
                    <img class="swiper-img" :src="item.url" @click="onBannerClick(item)" />
                </el-carousel-item>
            </el-carousel>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        bannerList: {
            type: Array,
            default() {
                return []
            },
            required: true
        }
    },
    data() {
        return {
            // swiperList: []
        }
    },
    methods: {
        onBannerClick(item) {
            if (item.redirectUrl != '') {
                this.$router.push({
                    path: item.redirectUrl,
                });
            }
        }
    },
    mounted() {

    }
}
</script>

<style scoped>
.swiper-img {
    width: 100%;
    height: 400px;
}
</style>


// WEBPACK FOOTER //
// src/components/module/home/imageCarousel.vue